import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Consent } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ConsentService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getConsent(id, schema = { id: null }): Promise<Consent> {
    return await this.core.services.consent.getById(id, schema)
  }

  async getConsents(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: Consent[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.consent.getList(parameters, schema)
  }

  createConsent(consent: Partial<Consent>, schema: Partial<Consent>): Promise<Consent> {
    return this.core.services.consent.create(consent, schema)
  }

  updateConsent(consent: Partial<Consent>, schema: Partial<Consent>): Promise<Consent> {
    return this.core.services.consent.update(consent, schema)
  }

  deleteConsent(consent: Partial<Consent>): Promise<Consent> {
    return this.core.services.consent.delete(consent)
  }
}
